<app-badge customToolTip
           [contentTemplate]="tooltip"
           [showToolTip]="(numberOfDimensions$ | async) > 0"
           *ngIf="enable$ | async">
  <app-source [item]="dimension$ | async"
              [enableTooltip]="false"></app-source>
  <ng-container *ngIf="numberOfDimensions$ | async">
    <span class="text-info">{{ 'reports.and_dimensions' | translate: { nbDimensions: numberOfDimensions$ | async } }}</span> <mat-icon class="material-icons-outlined info-icon">info</mat-icon>
  </ng-container>
</app-badge>
<ng-template #tooltip>
  <div class="display-flex flex-column row-gap-0-5rem">
    <app-source [item]="dimension.payload"
                [enableCategory]="true"
                *ngFor="let dimension of dimensions$ | async"></app-source>
  </div>
</ng-template>
